import fetchJobDetailService from 'api/jobDetailsService';

export const fetchJobDetailsInfo = {
  fetchJobDetails
};

async function fetchJobDetails(id, pageNumber, sortType, sortId) {
  try {
    const response = await fetchJobDetailService(
      id,
      pageNumber,
      sortType,
      sortId
    ).then((result) => result.json());
    return response;
  } catch (error) {
    return {
      message: error?.toString()
    };
  }
}